module.exports = __webpack_public_path__ + "static/img/s64.d08698c4.png";